import React, { useState, useEffect, useCallback, useContext } from "react";
import { OrganicationNavbar } from "../reusedcomponent/navbar";
// import CreaterequestModal from "./modal/create_request";
import CreateRequest from "./modal/create_request";
import EditrequestModal from "./modal/edit_request";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import { ConfirmTemplate } from "../../../../components/confirm";
import RejectModal from "./modal/reject";
import useModal from "../../../../utils/useModal";
import Modal from "react-modal";
import moment from "moment";
import { AuthContext } from "../../../../Context/AuthContext";
import { orgarnizationMngtThunk } from "../../../../store/actions/organizationmanagement/orgarnization.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { capitalize } from "../../../../utils/capitalize";
import { formattCurrency } from "../../../../utils/formatCurrency";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "white",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const OrganizationRequestIndex = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const [EditValue, setEditValue] = useState([]);
  const [rejectstate, SetRejectState] = useState([]);
  const [open, setOpen] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [filter, setFilter] = useState("");
  const [searchRequets, setSearchRequets] = useState("");

  const [Loading, setLoading] = useState(false);
  const load = <span className="fa fa-spin fa-spinner"></span>;

  const { modalIsOpen, openModal, closeModal } = useModal();

  const {
    allRequests,
    requestTypes,
    officeRequestsCategories,
    individualRequestsCategories,
    next,
    prev,
    currentPage,
    last,
  } = useSelector((state) => state.orgarnizationMngt);

  const dispatch = useDispatch();

  const Requests = !Array.isArray(allRequests)
    ? Object.values(allRequests)
    : allRequests;

  const openRejectModal = () => {
    setOpenReject(true);
  };

  const openEditModal = () => {
    setOpen(true);
  };

  const closeEditModal = () => {
    setOpen(false);
    setOpenReject(false);
  };

  const deleteRequest = (id, request_type, description) => {
    const request = async () => {
      const request_id = {
        request_id: id,
        request_type: request_type,
        description: description,
      };
      const res = await ApiService.delete(`requests/delete-request/${id}`);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        handleFetchRequest();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Request",
        message: "Are You Sure You Want To Delete This Request",
      },
      request
    );
  };

  const approveRequest = (id) => {
    const request = async () => {
      const request_id = {
        request_id: [id],
      };
      const res = await ApiService.post("requests/approve-request", request_id);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        handleFetchRequest();
      }
    };
    ConfirmTemplate(
      {
        title: "Approve Request",
        message: "Are You Sure You Want To Approve This Request",
      },
      request
    );
  };

  const rejectRequests = async (ids, reason) => {
    const request_id = {
      request_id: ids,
      reason_for_rejection: reason,
    };
    const res = await ApiService.post("requests/reject-request", request_id);
    if (res.data.type === false) {
      alert.error(res.data.msg);
    } else if (res.data.type === true) {
      alert.success(res.data.msg);
    }
    handleFetchRequest();
  };

  const rejectRequest = (id, reason) => {
    const request = async () => {
      const request_id = {
        request_id: [id],
        reason_for_rejection: reason,
      };
      const res = await ApiService.post("requests/reject-request", request_id);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        handleFetchRequest();
      }
    };
    ConfirmTemplate(
      {
        title: "Reject Request",
        message: "Are You Sure You Want To Reject This Request",
      },
      request
    );
  };

  const handleFetchRequest = useCallback(
    async (query) => {
      console.log("next", query);
      setLoading(true);
      await dispatch(orgarnizationMngtThunk.getAllRequest(query));
      setLoading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    handleFetchRequest();
  }, []);

  useEffect(() => {
    if (filter === "0") {
      handleFetchRequest();
    }
  }, [filter]);

  const allOfficeReq = Requests.filter((request) => {
    return (
      (request &&
        request.created_by.first_name
          .toLowerCase()
          .indexOf(searchRequets.toLowerCase()) !== -1) ||
      request.request_type.name
        .toLowerCase()
        .indexOf(searchRequets.toLowerCase()) !== -1 ||
      (request.request_category &&
        request.request_category.name
          .toLowerCase()
          .indexOf(searchRequets.toLowerCase()) !== -1) ||
      (request.price &&
        request.price
          .toString()
          .toLowerCase()
          .indexOf(searchRequets.toLowerCase()) !== -1)
    );
  });

  let activePage = currentPage;

  return (
    <React.Fragment>
      {/* <PageBody isLoading={isLoading} message={message}> */}
      <OrganicationNavbar />
      <Modal
        isOpen={openReject}
        onRequestClose={closeEditModal}
        style={customStyles}
        contentLabel="view user datails modal"
      >
        <RejectModal
          rejectRequest={rejectRequest}
          alert={alert}
          request={rejectstate}
          // rejectManyState={rejectManyState}
          closeModal={closeEditModal}
          // rejectManyRequest={rejectManyRequest}
          orgarnizationMngmnt={handleFetchRequest}
          rejectRequests={rejectRequests}
        />
      </Modal>
      <Modal
        isOpen={open}
        onRequestClose={closeEditModal}
        style={customStyles}
        contentLabel="view user datails modal"
      >
        <EditrequestModal
          alert={alert}
          requestType={requestTypes}
          value={EditValue}
          closeModal={closeEditModal}
          getAllRequest={handleFetchRequest}
          SetRejectState={SetRejectState}
          approveRequest={approveRequest}
          openRejectModal={openRejectModal}
          rejectRequest={rejectRequest}
          setOpenReject={setOpenReject}
          officeRequestsCategories={officeRequestsCategories}
          individualRequestsCategories={individualRequestsCategories}
          user={user.data.user}
        />
      </Modal>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="view user datails modal"
      >
        <CreateRequest
          alert={alert}
          requestType={requestTypes}
          closeModal={closeModal}
          getAllRequest={handleFetchRequest}
          officeRequestsCategories={officeRequestsCategories}
          individualRequestsCategories={individualRequestsCategories}
        />
      </Modal>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <div className="card-title">
                    <div className="table-title">
                      <div className="row container-fluid">
                        <div className="col-sm-6">
                          <h2>
                            <b>REQUEST </b>
                          </h2>
                        </div>
                        <div className="col-sm-6">
                          <button
                            onClick={openModal}
                            className="btn nt-button-color-action"
                            data-toggle="modal"
                          >
                            <i className="material-icons">&#xE147; </i>{" "}
                            <span>CREATE REQUEST</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 clearfix">
                    <div
                      class="btn-group float-left"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button
                        type="button"
                        class="btn btn-secondary btn-group-sm"
                        onClick={() => window.print()}
                      >
                        Print
                      </button>
                      <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="btn btn-secondary btn-group-sm"
                        table="office-request"
                        filename="OFFICE REQUEST"
                        sheet="tablexls"
                        buttonText="Export to excel"
                      />
                    </div>
                    <form class="form-inline my-2 my-lg-0 float-right">
                      <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                        name="search"
                        value={searchRequets}
                        onChange={(e) => setSearchRequets(e.target.value)}
                      />
                    </form>
                  </div>
                  <div className="table-responsive">
                    <table
                      id="office-request"
                      className="table table-bordered office-request-table"
                    >
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Employee Name</th>
                          <th>Request Type </th>
                          <th>Sub Category</th>
                          <th>Description</th>
                          <th>Price</th>
                          <th>Date Requested</th>
                          <th>Date Approved</th>
                          <th>Approved By</th>

                          <th>Status</th>

                          <th
                            style={{
                              width: "40px",
                            }}
                            className="notexport"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {allOfficeReq.map((request, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {capitalize(request.created_by.first_name) +
                                " " +
                                capitalize(request.created_by.last_name)}
                            </td>
                            <td>{capitalize(request.request_type.name)}</td>
                            <td>
                              {request.request_category
                                ? capitalize(request.request_category.name)
                                : null}
                            </td>
                            <td>{capitalize(request.description)}</td>
                            <td>₦ {formattCurrency(request.price)}</td>
                            <td>{moment(request.created_at).format("ll")}</td>
                            <td>
                              {request.approved_on
                                ? moment(request.approved_on).format("ll")
                                : null}
                            </td>
                            <td>
                              {request.approved_by
                                ? capitalize(request.approved_by.first_name)
                                : null}
                            </td>

                            <td>
                              {request.status === 1 ? (
                                <label
                                  style={{
                                    color: "orange",
                                  }}
                                >
                                  PENDING
                                </label>
                              ) : null}
                              {request.status === 2 ? (
                                <label
                                  style={{
                                    color: "green",
                                  }}
                                >
                                  APPROVED
                                </label>
                              ) : null}
                              {request.status === 3 ? (
                                <label
                                  style={{
                                    color: "darkred",
                                  }}
                                >
                                  REJECTED
                                </label>
                              ) : null}
                            </td>
                            <td>
                              <div class="dropdown">
                                <a
                                  href="#"
                                  class={`dropdown-toggle card-drop arrow-none ${
                                    request.status === 2 &&
                                    request.request_type.name !==
                                      "individual request" &&
                                    user.data.user.roles.name ===
                                      "human resource"
                                      ? ""
                                      : request.status === 1
                                      ? ""
                                      : "disabled d-none"
                                  }`}
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <h3 class="m-0 text-muted">
                                    <i class="fa fa-ellipsis-v"></i>
                                  </h3>
                                </a>
                                <div
                                  class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="btnGroupDrop1"
                                >
                                  {request.status === 2 &&
                                  request.request_type.name ===
                                    "office request" &&
                                  user.data.user.roles.name ===
                                    "human resource" ? (
                                    <Link
                                      class="dropdown-item"
                                      to={`/dashboard/organization/request/expendiure/${request.id}`}
                                    >
                                      Expenditure
                                    </Link>
                                  ) : null}

                                  {request.status === 1 ||
                                  user.data.user.id ===
                                    request.created_by.id ? (
                                    <a
                                      class="dropdown-item"
                                      id=""
                                      onClick={() => {
                                        const value = {
                                          request_id: request.id,
                                          request_type: request.request_type.id,
                                          description: request.description,
                                          price: request.price,
                                          request_category:
                                            request.request_category.id,
                                        };
                                        setEditValue(value);
                                        openEditModal();
                                      }}
                                    >
                                      {user.data.user.roles &&
                                      user.data.user.roles.name === "admin"
                                        ? "Manage"
                                        : "Edit"}
                                    </a>
                                  ) : null}

                                  {request.status === 1 ? (
                                    <a
                                      class="dropdown-item"
                                      id=""
                                      onClick={() => {
                                        deleteRequest(
                                          request.id,
                                          request.request_type.id,
                                          request.description
                                        );
                                      }}
                                    >
                                      Delete
                                    </a>
                                  ) : null}
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <nav aria-label="...">
                      <ul class="pagination">
                        <li
                          class={`page-item ${prev === null ? "disabled" : ""}`}
                        >
                          <a
                            class="page-link"
                            onClick={() => handleFetchRequest(prev)}
                            aria-disabled={
                              !allRequests.prev_page_url ? "true" : "false"
                            }
                            // aria-disabled={activityLog.prev_page_url}
                          >
                            Previous
                          </a>
                        </li>
                        {[...Array(last).keys()].map((page, i) => (
                          <li
                            class={`page-item ${
                              page + 1 === activePage ? "active" : ""
                            }`}
                            key={i}
                          >
                            <a
                              class="page-link"
                              id={page + 1}
                              onClick={() =>
                                handleFetchRequest(`?page=${page + 1}`)
                              }
                            >
                              {page + 1}
                            </a>
                          </li>
                        ))}
                        <li
                          class={`page-item ${next === null ? "disabled" : ""}`}
                        >
                          <a
                            class="page-link"
                            onClick={() => handleFetchRequest(next)}
                          >
                            {Loading ? load : "Next"}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </PageBody> */}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/request/index.js